<template >
  <div class="card dash-card barctrl" v-if="recommend" >
    <div class="card-header dash-card-header" style="height: 20px; background: transparent; ">
      <div class="center bold" :class="{ narrow_10 : isNarrow }" style="margin-top:1px; margin-bottom: 3px;">{{ title }}<span v-if="hasAsterisk">&nbsp;*</span></div>
    </div>
    <div class="card-body dash-card-body card-body-spacer">
      <div style="margin:0px 4px;">
        <table class="tbl-table tbl-th tbl-tr tbl-td" style="font-size: 7pt;">
          <thead>
            <tr class="tbl-tr tbl-bg tbl-cell-s" style="font-size: 7pt;" v-bind:class="{ headerHeight : isHeaderRotated }">
              <th class="left">{{$t('Webportal.DashboardBMW.NPS')}}</th>
              <th style="font-size: 7pt;">{{$t('Webportal.DashboardBMW.Score')}}</th>
              <th v-bind:class="{ headerSize : isHeaderRotated }" v-if="isBmwM" v-for="(wave, index1) in recommend.SurveyWave" :key="index1">
                <div v-if="isHeaderRotated" style="margin-bottom: -14px;" id="rotated">{{ wave.PropertyValue }}</div>
                <div v-if="!isHeaderRotated">{{ wave.PropertyValue }}</div>
              </th>
              <th v-if="!isBmwM" v-for="(wave, index2) in recommend.SurveyWave" :key="index2">
                {{ wave.Name }}
              </th>
              <th  v-bind:class="{ headerSize : isHeaderRotated }">
                <div v-if="isHeaderRotated" style="margin-bottom: -14px;" id="rotated">{{$t('Webportal.DashboardBMW.NumberOfShops')}}</div>
                <div v-if="!isHeaderRotated">{{$t('Webportal.DashboardBMW.NumberOfShops')}}</div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr class="tbl-tr tbl-cell-s regular">
              <td class="left">{{proHeader}}</td>
              <td>{{ recommend.ScorePromoters }}</td>
              <td class="bc-green" v-for="(wave, index) in recommend.SurveyWave" :key="index">{{ wave.ResultPromoters }}</td>
              <td>{{ recommend.Promoters }}</td>
            </tr>
            <tr class="tbl-tr tbl-cell-s regular">
              <td class="left">{{neutralHeader}}</td>
              <td>{{ recommend.ScorePassives }}</td>
              <td v-for="(wave, index) in recommend.SurveyWave" :key="index">{{ CalculatePassives(wave) }}</td>
              <td>{{ recommend.Passives }}</td>
            </tr>
            <tr class="tbl-tr tbl-cell-s regular">
              <td class="left">{{contraHeader}}</td>
              <td>{{ recommend.ScoreDetractors }}</td>
              <td class="bc-red" v-for="(wave, index) in recommend.SurveyWave" :key="index">{{ wave.ResultDetractors }}</td>
              <!-- <td>10</td>
              <td>0</td> -->
              <td>{{ recommend.Detractors }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'RecommendationTable',

    props:[
      'hasAsterisk',
      'recommend',
      'isCompetitionOverall',
      'proHeader',
      'contraHeader',
      'neutralHeader',
      'title',
      'isBmwM',
      'isHeaderRotated',
      'isNarrow'
    ],

    methods: {
      CalculatePassives(wave)  {
        let sum = wave.ResultPromoters + wave.ResultPassives + wave.ResultDetractors;
        if (sum === 100) return wave.ResultPassives;
        return 100 - wave.ResultPromoters - wave.ResultDetractors;
      }
    }
  }
</script>


<style scoped>
.card-body-spacer {
  padding: 0px;
}
.rec_card_body{
    margin: 2px;
    padding: 0px;
    width: 100%;
}

.head10 {
  width:10%;
}
.head40 {
  width:40%;
}

#nsc {
  float: right;
  line-height: 1.1
}

.home {
  overflow: hidden;
  display: inline-block;
  text-overflow: ellipsis;
  background: transparent;
}

#rotated {
    -webkit-transform: rotate(-90deg);
    -moz-transform: rotate(-90deg);
    -o-transform: rotate(-90deg);
    -ms-transform: rotate(-90deg);
    transform: rotate(-90deg);
}

.headerHeight {
  height: 16mm;
}

.headerSize {
  max-width: 14px;
}
</style>
